module.exports = __webpack_public_path__ + "img/nav_logo2.587b886d.png";